// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audioInformation_root__1wVvF {\n  max-width: 350px;\n  width: 100%;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 22px;\n  color: #343b4c;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n  .audioInformation_root__1wVvF .audioInformation_content__1HTBR {\n    display: flex;\n    flex-direction: column;\n    align-items: baseline; }\n    .audioInformation_root__1wVvF .audioInformation_content__1HTBR .audioInformation_info__Ar10t {\n      align-self: baseline; }\n      .audioInformation_root__1wVvF .audioInformation_content__1HTBR .audioInformation_info__Ar10t .audioInformation_title__2m158,\n      .audioInformation_root__1wVvF .audioInformation_content__1HTBR .audioInformation_info__Ar10t .audioInformation_writer__u0NOv {\n        margin: 0 5px; }\n", ""]);
// Exports
exports.locals = {
	"root": "audioInformation_root__1wVvF",
	"content": "audioInformation_content__1HTBR",
	"info": "audioInformation_info__Ar10t",
	"title": "audioInformation_title__2m158",
	"writer": "audioInformation_writer__u0NOv"
};
module.exports = exports;
